import { Component } from '@angular/core';

@Component({
  selector: 'spinner',
  template: `
      <i class="spinner"></i>
  `,
  styleUrls: [ 'spinner.component.scss' ]
})
export class SpinnerComponent {
}
